import httpClient from './httpClient';
import { httpRootClient } from './httpClient';
import store from '@/store';

const baseEndPoint = '/v3/users';

const login = user => httpClient.post(`${baseEndPoint}/login`, user);

const gowgoLogin = login => httpRootClient.post(`/login`, login);

const profile = () =>
  httpClient.get(`${baseEndPoint}/profile`, {
    auth: store.getters['register/userToken'],
  });
const setPin = newPin =>
  httpClient.post(
    `${baseEndPoint}/pin`,
    { newPin },
    {
      auth: store.getters['register/userToken'],
    },
  );

export default {
  login,
  profile,
  setPin,
  gowgoLogin,
};
